import { Avatar, Badge, Button, Chip, EmptyState, Icon, type BadgeTone } from "@helmr/ui";
import { Link } from "react-router-dom";
import type { Scope } from "./hooks";
import { areaAllows } from "../../app/nav";
import type { Lead, Stage } from "../../api/leads";
import { leads as t } from "./strings";

export const leadName = (l: Pick<Lead, "name">) => l.name?.trim() || t.unnamed;
export const sourceLabel = (source: string) => t.sources[source.toLowerCase()] ?? source;

const STAGE_TONE: Record<Stage["type"], BadgeTone> = { open: "info", won: "ok", lost: "neutral" };
export function StageBadge({ stage }: { stage: Stage | undefined }) {
  return stage ? <Badge tone={STAGE_TONE[stage.type]} dot>{stage.name}</Badge> : null;
}
export const SourceChip = ({ source }: { source: string }) => <Chip kind="enquiry">{sourceLabel(source)}</Chip>;

export function Owner({ id, name }: { id: string | null; name: string | null }) {
  if (!id) return <span style={{ color: "var(--color-text-tertiary)" }}>{t.noOwner}</span>;
  if (!name) return <span style={{ color: "var(--color-text-tertiary)" }}>—</span>;
  return <span style={{ display: "inline-flex", alignItems: "center", gap: 6, minWidth: 0 }}><Avatar id={id} name={name} size="xs" /><span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</span></span>;
}

/** The Add-lead and Convert forms want a native select; this keeps the control height and ring consistent. */
export const fieldId = (prefix: string, name: string) => `${prefix}-${name}`;

export function LeadsEmpty({ sc, filtered }: { sc: Scope; filtered: boolean }) {
  if (filtered) return <EmptyState icon="search" title={t.empty.noMatch} description={t.empty.noMatchBody} />;
  return (
    <EmptyState
      icon="inbox"
      title={t.empty.title}
      description={t.empty.body}
      action={<>
        {sc.ctx.has("leads.add") ? <Button as={Link} to="/leads/new" variant="primary"><Icon name="plus" />{t.add}</Button> : null}
        {areaAllows("settings", sc.ctx.has) ? <Button as={Link} to="/settings">{t.empty.settings}</Button> : null}
      </>}
    />
  );
}
